const ORDER = [
  "sign_contract_a_url",
  "sign_contract_b_url",
  "contract",
  "identity",
  "identity_back",
  "cpf",
  "vaccination_record",
  "proof_of_residence",
  "identity_contractor_a",
  "identity_contractor_a_back",
  "identity_contractor_b",
  "identity_contractor_b_back",
  "cpf_contractor_a",
  "cpf_contractor_b",
  "transference_declaration",
  "discharge",
  "school_record",
];

function sortEnrollmentDocuments(documents) {
  if (!documents || !Array.isArray(documents)) {
    return documents || [];
  }

  const documentsWithSortedFiles = documents.map((document) => {
    if (!document.files || !Array.isArray(document.files)) {
      return document;
    }

    const sortedFiles = [...document.files].sort((a, b) => {
      const indexA = ORDER.indexOf(a.fileName);
      const indexB = ORDER.indexOf(b.fileName);

      if (indexA === -1 && indexB === -1) {
        return 0;
      }

      if (indexA === -1) {
        return 1;
      }

      if (indexB === -1) {
        return -1;
      }

      return indexA - indexB;
    });

    return {
      ...document,
      files: sortedFiles,
    };
  });

  const sortedDocuments = documentsWithSortedFiles.sort((docA, docB) => {
    const firstFileA =
      docA.files && docA.files[0] ? docA.files[0].fileName : "";
    const firstFileB =
      docB.files && docB.files[0] ? docB.files[0].fileName : "";

    const indexA = ORDER.indexOf(firstFileA);
    const indexB = ORDER.indexOf(firstFileB);

    if (indexA === -1 && indexB === -1) return 0;
    if (indexA === -1) return 1;
    if (indexB === -1) return -1;

    return indexA - indexB;
  });

  return sortedDocuments;
}

export { sortEnrollmentDocuments };
